import type { UserFormOutput } from '../../pages/Profile/UserProfileSettings/ZodValidationSchema'

const trimStr = (s: string) => s.trim()

const birthdayIsoEqual = (a: UserFormOutput['birthday'], b: UserFormOutput['birthday']) =>
  a.format('YYYY-MM-DD') === b.format('YYYY-MM-DD')

const numberArraysEqual = (a: number[], b: number[]) => {
  if (a.length !== b.length) return false
  return a.every((v, i) => v === b[i])
}

const imageComparable = (v: UserFormOutput['image']): string | 'file' => {
  if (v instanceof File) return 'file'
  if (v == null) return ''
  return trimStr(String(v))
}

const imagesEqual = (a: UserFormOutput['image'], b: UserFormOutput['image']) => {
  const ca = imageComparable(a)
  const cb = imageComparable(b)
  if (ca === 'file' || cb === 'file') {
    return ca === 'file' && cb === 'file' && a instanceof File && b instanceof File && a === b
  }
  return ca === cb
}

/**
 * Сравнение двух результатов `userFormSchema.parse(...)` по тем же правилам,
 * что и при отправке (trim строк, порядок id как в форме, image: File vs строка).
 */
export function areProfileFormOutputsEqual(a: UserFormOutput, b: UserFormOutput): boolean {
  if (trimStr(a.surname) !== trimStr(b.surname)) return false
  if (trimStr(a.name) !== trimStr(b.name)) return false
  if (trimStr(a.otch) !== trimStr(b.otch)) return false
  if (trimStr(a.slug) !== trimStr(b.slug)) return false
  if (a.status !== b.status) return false
  if (!birthdayIsoEqual(a.birthday, b.birthday)) return false
  if (trimStr(a.slogan) !== trimStr(b.slogan)) return false
  if (trimStr(a.region) !== trimStr(b.region)) return false
  if (trimStr(a.city) !== trimStr(b.city)) return false
  if (trimStr(a.work) !== trimStr(b.work)) return false
  if (trimStr(a.description) !== trimStr(b.description)) return false
  if (trimStr(a.full_description) !== trimStr(b.full_description)) return false
  if (!imagesEqual(a.image, b.image)) return false
  if (!numberArraysEqual(a.competencyIds, b.competencyIds)) return false
  if (!numberArraysEqual(a.resourceIds, b.resourceIds)) return false
  if (!numberArraysEqual(a.participationIds, b.participationIds)) return false
  if (!numberArraysEqual(a.improvementIds, b.improvementIds)) return false
  if (a.matchingRemoteAllowed !== b.matchingRemoteAllowed) return false
  return true
}

export const isProfileFormUnchanged = (
  current: UserFormOutput,
  baseline: UserFormOutput
): boolean => areProfileFormOutputsEqual(current, baseline)
